import React from 'react';

import Icon from '../iconBase';

import './icon__up.scss';

const IconUp = (props) => (
    <Icon {...props} ico="up">
        <svg height="50" preserveAspectRatio="xMidYMid" viewBox="0 0 266 349" width="50">
            <path d="m201.42894,161.33148l-59.66611,-59.66613l0,174.63064l-13.96367,0l0,-174.63064l-59.66611,59.66613l-9.87405,-9.87407l66.64795,-66.64794l0,0l9.87406,-9.87347l76.522,76.52199l-9.87407,9.87349z" />
        </svg>
    </Icon>
);

export default IconUp;
